import { cn } from "@/lib/utils"

type GaugeProps = {
  value: number
  size?: "sm" | "md" | "lg"
  label: string
}

export default function Gauge({ value, size = "md", label }: GaugeProps) {
  const strokeWidth = size === "sm" ? 8 : size === "md" ? 12 : 16
  const radius = size === "sm" ? 40 : size === "md" ? 60 : 80
  const circumference = 2 * Math.PI * radius
  const progress = (value / 100) * circumference

  return (
    <div className="flex flex-col items-center">
      <svg
        className={cn("transform -rotate-90", size === "sm" ? "w-20 h-20" : size === "md" ? "w-32 h-32" : "w-40 h-40")}
        viewBox={`0 0 ${radius * 2 + strokeWidth} ${radius * 2 + strokeWidth}`}
      >
        <circle
          className="text-muted-foreground"
          strokeWidth={strokeWidth}
          stroke="currentColor"
          fill="transparent"
          r={radius}
          cx={radius + strokeWidth / 2}
          cy={radius + strokeWidth / 2}
        />
        <circle
          className="text-green-500" // Changed from text-primary to text-green-500
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={circumference - progress}
          strokeLinecap="round"
          stroke="currentColor"
          fill="transparent"
          r={radius}
          cx={radius + strokeWidth / 2}
          cy={radius + strokeWidth / 2}
        />
      </svg>
      <div className="mt-2 text-center">
        <div className="text-2xl font-bold">{value}%</div>
        <div className="text-sm text-muted-foreground">{label}</div>
      </div>
    </div>
  )
}

